import React from 'react';
import Svg, { Path, Rect } from 'react-native-svg';
import { Ionicons } from '@expo/vector-icons';

/** AI assistant icon: "bot" from Lucide (lucide.dev, ISC licence), drawn as strokes like the original. */
export function AiBotIcon({ size = 24, color = '#000' }: { size?: number; color?: string }) {
  const stroke = { stroke: color, strokeWidth: 2, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const, fill: 'none' };
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24">
      <Path d="M12 8V4H8" {...stroke} />
      <Rect width={16} height={12} x={4} y={8} rx={2} {...stroke} />
      <Path d="M2 14h2" {...stroke} />
      <Path d="M20 14h2" {...stroke} />
      <Path d="M15 13v2" {...stroke} />
      <Path d="M9 13v2" {...stroke} />
    </Svg>
  );
}

/** Ionicons name, or one of our own icons ('ai-bot'). */
export type AppIconName = keyof typeof Ionicons.glyphMap | 'ai-bot';

export function AppIcon({ name, size, color }: { name: AppIconName | string; size?: number; color?: string }) {
  if (name === 'ai-bot') return <AiBotIcon size={size} color={color} />;
  return <Ionicons name={name as keyof typeof Ionicons.glyphMap} size={size} color={color} />;
}
